import type React from 'react';
import { defineMessages, IntlShape, useIntl } from 'react-intl';
import { Icon } from '@plone/volto/components';
import calendarSVG from '@plone/volto/icons/calendar.svg';
import clockSVG from '@plone/volto/icons/clock.svg';

import { formatDateLabel, formatDay, formatTimeRangeLabel } from 'volto-apanymantel/helpers';

const messages = defineMessages({
  
});

interface Timetable {
  fromDate: string | null;
  toDate: string | null;
  repeatEveryYear: boolean | null;
  day: 0 | 1 | 2 | 3 | 4 | 5 | 6 | null;
  fromTime: string;
  toTime: string;
}

interface Items {
  items: Timetable[];
}

interface TimetableWidgetProps {
  value: Items;
}

const TimetableWidget: React.FC<TimetableWidgetProps> = ({ value }) => {
  const intl = useIntl();

  if (!value?.items || value.items.length === 0) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {value.items.map((item, index) => {
        const hideYear = item?.repeatEveryYear === true;
        const fromDateLabel = formatDateLabel(item?.fromDate, intl, { hideYear });
        const toDateLabel = formatDateLabel(item?.toDate, intl, { hideYear });
        const timeRangeLabel = formatTimeRangeLabel(item.fromTime, item.toTime, intl);
        const dayLabel = formatDay(item.day, true, intl);

        const dateRange = (() => {
          if (item?.fromDate && item?.fromDate === item?.toDate) {
            return fromDateLabel;
          }
          if (fromDateLabel && toDateLabel) {
            return `${fromDateLabel} - ${toDateLabel}`;
          }
          if (fromDateLabel || toDateLabel) {
            return fromDateLabel || toDateLabel;
          }
          return null;
        })();

        return (
          <div
            key={index}
            style={{
              display: 'flex',
              gap: '24px',
              alignItems: 'center',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Icon name={calendarSVG} size="24px" />
              <div style={{ textAlign: 'center', minWidth: '200px' }}>
                {dateRange &&
                  <> 
                    {dateRange}
                    {dayLabel && <span style={{ marginLeft: '8px' }}>({dayLabel})</span>}
                  </>}
                {!dateRange && dayLabel && <span style={{ marginLeft: '8px' }}>{dayLabel}</span>}
              </div>
            </div>
            {timeRangeLabel && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Icon name={clockSVG} size="24px" />
                <span>{timeRangeLabel}</span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TimetableWidget;
